const loggingLevels = [
  'trace',
  'debug',
  'info',
  'warn',
  'error',
  'silent',
] as const;

export type LoggingLevel = (typeof loggingLevels)[number];

export const isLoggingLevel = (string: string): string is LoggingLevel =>
  loggingLevels.includes(string as LoggingLevel);

export interface LoggingService {
  setLevel: (level: LoggingLevel) => void;
  trace: (...msg: Array<any>) => void;
  debug: (...msg: Array<any>) => void;
  log: (...msg: Array<any>) => void;
  info: (...msg: Array<any>) => void;
  warn: (...msg: Array<any>) => void;
  error: (...msg: Array<any>) => void;
}

export { LogLevelLoggingService } from './LogLevelLoggingService';
export { loggingServiceFactory as factory } from './loggingServiceFactory';
